<script lang="ts">
  interface Props {
    value: unknown;
    name?: string | undefined;
    id?: string | undefined;
    ariaLabel?: string | undefined;
    class?: string;
    children?: import("svelte").Snippet;
    onchange?: (event: Event) => void;
  }

  let {
    value = $bindable(),
    name,
    id,
    ariaLabel,
    class: classes = "",
    children,
    onchange,
  }: Props = $props();
</script>

<select
  class="button text-start pr-3rem {classes}"
  bind:value
  {name}
  {id}
  {onchange}
  aria-label={ariaLabel}
>
  {@render children?.()}
</select>

<style lang="postcss">
  /* Select button */
  select {
    --icon: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1em' height='1em' viewBox='0 0 256 256'%3E%3Cpath fill='%23002987' d='m213.66 101.66l-80 80a8 8 0 0 1-11.32 0l-80-80A8 8 0 0 1 48 88h160a8 8 0 0 1 5.66 13.66'/%3E%3C/svg%3E");
    background:
      no-repeat 100% center / 1rem 1rem var(--icon),
      var(--bg-button, var(--bg, transparent));
    background-position: calc(100% - 1rem) center;
  }
</style>
